import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { Typography } from '../../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../context/ViewContext/ViewContext.js';
import '../../../utils/constants/colors.js';
import '../../../shared/consts/index.js';
import '../../../context/DynamicContext/DynamicContext.js';
import '../../../components/ShadowDOM/ShadowDOM.js';
import '../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../config/ApiEndpoint.js';
import '../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../context/MockContext/MockContext.js';
import '../../../context/CaptchaContext/CaptchaContext.js';
import '../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../components/IconButton/IconButton.js';

const SearchInstead = () => (jsxs("div", Object.assign({ className: 'search-instead__container' }, { children: [jsx(Typography, Object.assign({ color: 'secondary', variant: 'body_small', weight: 'regular' }, { children: "Don't see your wallet?" })), jsx(Typography, Object.assign({ color: 'primary', variant: 'button_primary', weight: 'regular' }, { children: "Try search instead" }))] })));

export { SearchInstead };
